import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store.ts";

import axios from 'axios';
type Appt = {
    id: string;
    kunde: string;
    start: string;
    slutt: string;
    type: "Chat" | "Samtale" | "Video";
    status: "Planlagt" | "Fullført" | "Avlyst";
    belop: number;
};
type appointmentProps = {
    newName: string,
    setNewName: (tab: string) => void,
    newType: string,
    setNewType: React.Dispatch<React.SetStateAction<"Chat" | "Samtale" | "Video">>,
    newStart: string,
    setNewStart: (tab: string) => void,
    pricingMode: string,
    consultDuration: number,
    slotMinutes: number,
    consultPrice: any,
    minutePrice: any,
    addAppt: any,
    NOK: (n: number) => string,
    appts: Appt[],
    setAppts: React.Dispatch<React.SetStateAction<Appt[]>>,
    currentUser: any,
    baseUrl: string,
};

export default function Appointments({ newName, setNewName, newType, setNewType, newStart, setNewStart, pricingMode, consultDuration, slotMinutes, consultPrice, minutePrice, addAppt, NOK, appts, setAppts, currentUser, baseUrl}: appointmentProps) {
    const [loading, setLoading] = useState(true);
    const client = useSelector((state: RootState) => state.client.client);
    const client_uid = client.uid || "clnt_QI9Jd1m0"; // fallback to default if not available
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const res = await axios.get(baseUrl + "/getAgentAppointments", {
                    params: { token: currentUser.token, client_uid: client_uid },
                })

                console.log(res.data.data);

                setAppts(res.data.data);
            } catch (err) {
                console.error("Error fetching agent:", err);
            } finally {
                setLoading(false);

            }
        }

        fetchAppointments();
    }, [currentUser?.token, baseUrl])
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                    <p className="mt-3 text-gray-600 animate-pulse">Laster inn profil…</p>
                </div>
            </div>
        );
    }
    return (
        <>
            <h3 className="font-bold text-purple-900 mb-2">Dine avtaler</h3>

            {/* Ny avtale */}
            <div className="mb-4 rounded-xl border p-3 bg-purple-50/40">
                <div className="grid md:grid-cols-5 gap-2 text-sm items-end">
                    <div>
                        <label className="block text-xs text-gray-600">Kunde</label>
                        <input value={newName} onChange={e => setNewName(e.target.value)} className="w-full rounded-lg border px-2 py-1" placeholder="Navn" />
                    </div>
                    <div>
                        <label className="block text-xs text-gray-600">Start</label>
                        <input type="datetime-local" value={newStart} onChange={e => setNewStart(e.target.value)} className="w-full rounded-lg border px-2 py-1" />
                    </div>
                    <div>
                        <label className="block text-xs text-gray-600">Type</label>
                        <select value={newType} onChange={e => setNewType(e.target.value as any)} className="w-full rounded-lg border px-2 py-1">
                            <option>Chat</option>
                            <option>Samtale</option>
                            <option>Video</option>
                        </select>
                    </div>
                    <div className="text-gray-700">
                        <div className="text-xs">Varighet</div>
                        <div className="font-semibold">{pricingMode === 'per_consult' ? consultDuration : slotMinutes} min</div>
                        <div className="text-[11px] text-gray-500">Pris: {pricingMode === 'per_consult' ? NOK(consultPrice) : NOK(minutePrice)}{pricingMode === 'per_min' && '/min'}</div>
                    </div>
                    <div className="text-right">
                        <button onClick={addAppt} className="rounded-full bg-purple-600 text-white px-4 py-2">Opprett</button>
                    </div>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead>
                        <tr className="text-left text-gray-600">
                            <th className="p-2">Kunde</th>
                            <th className="p-2">Start</th>
                            <th className="p-2">Slutt</th>
                            <th className="p-2">Type</th>
                            <th className="p-2">Status</th>
                            <th className="p-2">Beløp</th>
                            <th className="p-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {appts.map(a => (
                            <tr key={a.id} className="border-t">
                                <td className="p-2">{a.kunde}</td>
                                <td className="p-2">{a.start.replace("T", " ")}</td>
                                <td className="p-2">{a.slutt.replace("T", " ")}</td>
                                <td className="p-2">{a.type}</td>
                                <td className="p-2">{a.status}</td>
                                <td className="p-2">{NOK(a.belop)}</td>
                                <td className="p-2 text-right">
                                    {a.status === "Planlagt" && (
                                        <div className="flex gap-2 justify-end">
                                            <button onClick={() => setAppts(list => list.map(x => x.id === a.id ? { ...x, status: "Fullført" } : x))} className="text-green-700 hover:underline">Fullfør</button>
                                            <button onClick={() => setAppts(list => list.map(x => x.id === a.id ? { ...x, status: "Avlyst" } : x))} className="text-red-600 hover:underline">Avlys</button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}